export const getUrlParam = (key: string) => {
  const url = new URL(location.href)
  return url.searchParams.get(key)
}

export const setUrlParam = (key: string, value: string | number | undefined) => setUrlParams({ [key]: value })

export const setUrlParams = (params: { [key: string]: string | number | undefined }) => {
  const url = new URL(location.href)
  Object.entries(params).forEach(([ key, value ]) => {
    if (value !== undefined) {
      url.searchParams.set(key, String(value))
    } else {
      url.searchParams.delete(key)
    }
  })
  if ('replaceState' in history) {
    history.replaceState('', '', url)
  }
}

export const setHash = (hash: string) => {
  const url = new URL(window.location.href)
  url.hash = hash
  window.history.replaceState('', '', url.toString())
  window.dispatchEvent(new Event('replaceState'))
}
